import {
  GET_PRICING_OPTIONS_FAILED,
  GET_PRICING_OPTIONS_REQUEST,
  GET_PRICING_OPTIONS_SUCCESS,
} from "../../constants/Pricing/pricingConstants";

export const getPricingOptionsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PRICING_OPTIONS_REQUEST:
      return {
        loading: true,
      };
    case GET_PRICING_OPTIONS_SUCCESS:
      return {
        loading: false,
        pricingOption: action.payload,
      };
    case GET_PRICING_OPTIONS_FAILED:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
